import { addNotification } from "../../../actions/notifications";
import { setSettingsPage } from "../../../actions/session";
import ToolbarIcon from "../../../controls/ToolbarIcon";
import { ComponentEx, connect, translate } from "../../../controls/ComponentEx";
import { UserCanceled } from "../../../util/CustomErrors";
import { showError } from "../../../util/message";
import onceCB from "../../../util/onceCB";
import * as selectors from "../../../util/selectors";
import { getSafe } from "../../../util/storeHelper";
import { NoDeployment } from "../util/exceptions";
import * as React from "react";
const nop = () => undefined;
class ActivationButton extends ComponentEx {
    render() {
        const { t, activator, needToDeploy } = this.props;
        return (React.createElement(ToolbarIcon, { id: "deploy-mods", icon: "deploy", text: t("Deploy Mods"), className: needToDeploy ? "toolbar-flash-button" : undefined, onClick: activator !== undefined ? this.activate : this.noMethod }));
    }
    noMethod = () => {
        const { onSetSettingsPage, onShowWarning } = this.props;
        onShowWarning("You have to select a deployment method first", {
            title: "Fix",
            action: (dismiss) => {
                this.context.api.events.emit("show-main-page", "application_settings");
                onSetSettingsPage("Mods");
                dismiss();
            },
        }, "select-deployment-method-first");
    };
    activate = () => {
        this.context.api.events.emit("deploy-mods", onceCB((err) => {
            if (err !== null) {
                if (err instanceof UserCanceled) {
                    // Nothing to see here, move along.
                    return;
                }
                else if (err instanceof NoDeployment) {
                    this.props.onShowError("You need to select a deployment method in settings", undefined, false);
                }
                else {
                    this.props.onShowError("Failed to activate mods", err);
                }
            }
            else {
                this.context.api.sendNotification({
                    id: "mods-deployed",
                    type: "info",
                    message: "Mods deployed",
                    displayMS: 3000,
                });
            }
        }), this.props.profileId, undefined, { manual: true });
    };
}
function mapStateToProps(state, ownProps) {
    const gameId = selectors.activeGameId(state);
    const activatorId = getSafe(state, ["settings", "mods", "activator", gameId], undefined);
    const profileId = selectors.lastActiveProfileForGame(state, gameId);
    let activator;
    if (activatorId !== undefined) {
        activator = ownProps
            .getActivators()
            .find((act) => act.id === activatorId);
    }
    return {
        profileId,
        activator,
        needToDeploy: selectors.needToDeploy(state),
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onShowError: (message, details, allowReport) => showError(dispatch, message, details, { allowReport }),
        onShowWarning: (message, dialogAction, id) => dispatch(addNotification({
            id,
            type: "warning",
            message,
            actions: [dialogAction],
        })),
        onSetSettingsPage: (pageId) => dispatch(setSettingsPage(pageId)),
    };
}
export default translate(["common"])(connect(mapStateToProps, mapDispatchToProps)(ActivationButton));
